/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActiveAlertCountDTO } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { AlarmDTO } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { CustomErrorResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { PageLikeAlarmDTO } from '../n3-backend-open-api-gen/model';
/**
 * AlarmApi - axios parameter creator
 */
export const AlarmApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculates the total number of alarms that are both ACTIVE and unread for the current user. Used for UI notification badges.
         * @summary Get count of unread active alarms
         * @param {string} to Filter end date for count
         * @param {string} [from] Filter start date for count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeCount: async (to: string, from?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'to' is not null or undefined
            assertParamExists('activeCount', 'to', to)
            const localVarPath = `/api/v1/alarms/summary/active-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the notification status of a specific alarm to \'read\'. This affects the unread count returned by the \'active-count\' endpoint.
         * @summary Mark alarm notification as read
         * @param {number} id The ID of the alarm notification record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markAsRead', 'id', id)
            const localVarPath = `/api/v1/alarms/summary/{id}/read`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a paginated list of historical alarms for a given device. Results can be filtered by a time range using \'from\' and \'to\' parameters.
         * @summary Get alarms for a specific device
         * @param {number} deviceId The internal unique ID of the meter device
         * @param {string} to End timestamp for the range filter (ISO 8601)
         * @param {string} [from] Start timestamp for the range filter (ISO 8601)
         * @param {number} [pageSize] Number of records per page
         * @param {number} [currentPage] Current page number (1-indexed)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurements: async (deviceId: number, to: string, from?: string, pageSize?: number, currentPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('measurements', 'deviceId', deviceId)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('measurements', 'to', to)
            const localVarPath = `/api/v1/alarms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a summary list of all alarms that are currently in ACTIVE status for all devices associated with the logged-in user. This is primarily used for dashboard views.
         * @summary Get active alarm summary for current user
         * @param {string} to End date for active alarm search
         * @param {string} [from] Optional start date for active alarm search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary: async (to: string, from?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'to' is not null or undefined
            assertParamExists('summary', 'to', to)
            const localVarPath = `/api/v1/alarms/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlarmApi - functional programming interface
 */
export const AlarmApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlarmApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculates the total number of alarms that are both ACTIVE and unread for the current user. Used for UI notification badges.
         * @summary Get count of unread active alarms
         * @param {string} to Filter end date for count
         * @param {string} [from] Filter start date for count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeCount(to: string, from?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveAlertCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeCount(to, from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlarmApi.activeCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the notification status of a specific alarm to \'read\'. This affects the unread count returned by the \'active-count\' endpoint.
         * @summary Mark alarm notification as read
         * @param {number} id The ID of the alarm notification record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRead(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlarmApi.markAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a paginated list of historical alarms for a given device. Results can be filtered by a time range using \'from\' and \'to\' parameters.
         * @summary Get alarms for a specific device
         * @param {number} deviceId The internal unique ID of the meter device
         * @param {string} to End timestamp for the range filter (ISO 8601)
         * @param {string} [from] Start timestamp for the range filter (ISO 8601)
         * @param {number} [pageSize] Number of records per page
         * @param {number} [currentPage] Current page number (1-indexed)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async measurements(deviceId: number, to: string, from?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLikeAlarmDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.measurements(deviceId, to, from, pageSize, currentPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlarmApi.measurements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a summary list of all alarms that are currently in ACTIVE status for all devices associated with the logged-in user. This is primarily used for dashboard views.
         * @summary Get active alarm summary for current user
         * @param {string} to End date for active alarm search
         * @param {string} [from] Optional start date for active alarm search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summary(to: string, from?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlarmDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summary(to, from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlarmApi.summary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlarmApi - factory interface
 */
export const AlarmApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlarmApiFp(configuration)
    return {
        /**
         * Calculates the total number of alarms that are both ACTIVE and unread for the current user. Used for UI notification badges.
         * @summary Get count of unread active alarms
         * @param {string} to Filter end date for count
         * @param {string} [from] Filter start date for count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeCount(to: string, from?: string, options?: RawAxiosRequestConfig): AxiosPromise<ActiveAlertCountDTO> {
            return localVarFp.activeCount(to, from, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the notification status of a specific alarm to \'read\'. This affects the unread count returned by the \'active-count\' endpoint.
         * @summary Mark alarm notification as read
         * @param {number} id The ID of the alarm notification record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAsRead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a paginated list of historical alarms for a given device. Results can be filtered by a time range using \'from\' and \'to\' parameters.
         * @summary Get alarms for a specific device
         * @param {number} deviceId The internal unique ID of the meter device
         * @param {string} to End timestamp for the range filter (ISO 8601)
         * @param {string} [from] Start timestamp for the range filter (ISO 8601)
         * @param {number} [pageSize] Number of records per page
         * @param {number} [currentPage] Current page number (1-indexed)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurements(deviceId: number, to: string, from?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageLikeAlarmDTO> {
            return localVarFp.measurements(deviceId, to, from, pageSize, currentPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a summary list of all alarms that are currently in ACTIVE status for all devices associated with the logged-in user. This is primarily used for dashboard views.
         * @summary Get active alarm summary for current user
         * @param {string} to End date for active alarm search
         * @param {string} [from] Optional start date for active alarm search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary(to: string, from?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlarmDTO>> {
            return localVarFp.summary(to, from, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlarmApi - object-oriented interface
 */
export class AlarmApi extends BaseAPI {
    /**
     * Calculates the total number of alarms that are both ACTIVE and unread for the current user. Used for UI notification badges.
     * @summary Get count of unread active alarms
     * @param {string} to Filter end date for count
     * @param {string} [from] Filter start date for count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activeCount(to: string, from?: string, options?: RawAxiosRequestConfig) {
        return AlarmApiFp(this.configuration).activeCount(to, from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the notification status of a specific alarm to \'read\'. This affects the unread count returned by the \'active-count\' endpoint.
     * @summary Mark alarm notification as read
     * @param {number} id The ID of the alarm notification record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markAsRead(id: number, options?: RawAxiosRequestConfig) {
        return AlarmApiFp(this.configuration).markAsRead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a paginated list of historical alarms for a given device. Results can be filtered by a time range using \'from\' and \'to\' parameters.
     * @summary Get alarms for a specific device
     * @param {number} deviceId The internal unique ID of the meter device
     * @param {string} to End timestamp for the range filter (ISO 8601)
     * @param {string} [from] Start timestamp for the range filter (ISO 8601)
     * @param {number} [pageSize] Number of records per page
     * @param {number} [currentPage] Current page number (1-indexed)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public measurements(deviceId: number, to: string, from?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig) {
        return AlarmApiFp(this.configuration).measurements(deviceId, to, from, pageSize, currentPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a summary list of all alarms that are currently in ACTIVE status for all devices associated with the logged-in user. This is primarily used for dashboard views.
     * @summary Get active alarm summary for current user
     * @param {string} to End date for active alarm search
     * @param {string} [from] Optional start date for active alarm search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public summary(to: string, from?: string, options?: RawAxiosRequestConfig) {
        return AlarmApiFp(this.configuration).summary(to, from, options).then((request) => request(this.axios, this.basePath));
    }
}

